
export const professional = {
  // Types
  professional: "Professional",
  inspirationalLeader: "Inspirational Leader",
  commander: "Commander",
  executive: "Executive",
  dynamicNetworker: "Dynamic Networker",
  visionaryLeader: "Visionary Leader",
  socialInnovator: "Social Innovator",
  strategicEntrepreneur: "Strategic Entrepreneur",
  specialist: "Specialist",
  achiever: "Achiever",
  pioneer: "Pioneer",
  independent: "Independent",
  teamBuilder: "Team Builder",
  supporter: "Supporter",
  influencer: "Influencer",
  networker: "Networker",
  systematizer: "Systematizer",
  facilitator: "Facilitator",
  collaborator: "Collaborator",
  harmonizer: "Harmonizer",

  // Descriptions
  professionalDescription: "A reliable and adaptable individual who values stability and consistency in their work.",
  inspirationalLeaderDescription: "A motivating leader who inspires others to achieve common goals.",
  commanderDescription: "A decisive leader who takes charge and drives results.",
  executiveDescription: "A strategic thinker who excels in leadership roles.",
  dynamicNetworkerDescription: "An outgoing individual who builds strong relationships and networks effectively.",
  visionaryLeaderDescription: "A forward-thinking leader with a clear vision for the future.",
  socialInnovatorDescription: "A creative problem-solver who drives positive change in society.",
  strategicEntrepreneurDescription: "A calculated risk-taker who identifies and capitalizes on business opportunities.",
  specialistDescription: "A highly skilled expert in a specific field.",
  achieverDescription: "A goal-oriented individual who consistently delivers results.",
  pioneerDescription: "An independent thinker who is not afraid to take risks and explore new ideas.",
  independentDescription: "A self-sufficient individual who thrives in autonomous environments.",
  teamBuilderDescription: "A collaborative team player who fosters a positive and inclusive work environment.",
  supporterDescription: "A compassionate individual who provides support and encouragement to others.",
  influencerDescription: "A persuasive communicator who can influence and inspire others.",
  networkerDescription: "A social butterfly who enjoys meeting new people and building connections.",
  systematizerDescription: "A detail-oriented individual who excels at organizing and streamlining processes.",
  facilitatorDescription: "A skilled mediator who helps teams work together effectively.",
  collaboratorDescription: "A team-oriented individual who enjoys working with others to achieve common goals.",
  harmonizerDescription: "A peacemaker who strives to create a harmonious and cooperative work environment.",

  // Key Traits
  professionalTraits: "Adaptable, Reliable, Consistent",
  inspirationalLeaderTraits: "Motivating, Inspiring, Charismatic",
  commanderTraits: "Decisive, Assertive, Results-oriented",
  executiveTraits: "Strategic, Visionary, Leadership-oriented",
  dynamicNetworkerTraits: "Outgoing, Sociable, Relationship-oriented",
  visionaryLeaderTraits: "Forward-thinking, Innovative, Strategic",
  socialInnovatorTraits: "Creative, Problem-solving, Change-oriented",
  strategicEntrepreneurTraits: "Calculated, Risk-taking, Business-oriented",
  specialistTraits: "Expert, Knowledgeable, Skilled",
  achieverTraits: "Goal-oriented, Results-driven, Efficient",
  pioneerTraits: "Independent, Risk-taking, Innovative",
  independentTraits: "Self-sufficient, Autonomous, Resourceful",
  teamBuilderTraits: "Collaborative, Inclusive, Supportive",
  supporterTraits: "Compassionate, Encouraging, Empathetic",
  influencerTraits: "Persuasive, Inspiring, Charismatic",
  networkerTraits: "Sociable, Outgoing, Connection-oriented",
  systematizerTraits: "Detail-oriented, Organized, Efficient",
  facilitatorTraits: "Mediator, Diplomatic, Cooperative",
  collaboratorTraits: "Team-oriented, Cooperative, Supportive",
  harmonizerTraits: "Peacemaker, Harmonious, Cooperative",

  // Work Style translations
  workStyle: {
    title: "Work Style Preferences",
    adaptableProfessional: "Adaptable and flexible with steady, consistent work environment preferences",
    leadsInspiration: "Leads through inspiration and motivation",
    buildsConsensus: "Builds consensus and drives team alignment",
    strategicLeadership: "Strategic leadership with long-term vision",
    networksSystematic: "Networks systematically while maintaining structure",
    structuredVision: "Structured approach to visionary thinking",
    patientInnovation: "Patient innovation with careful consideration",
    strategicEntrepreneurship: "Strategic entrepreneurship with calculated risks",
    independentExpertise: "Independent expertise with specialized knowledge",
    systematicGoal: "Systematic goal achievement with detailed planning",
    independentAction: "Independent action with self-directed approach",
    autonomousTask: "Autonomous task management with minimal supervision",
    collaborativeTeam: "Collaborative team building with inclusive approach",
    supportiveRelationship: "Supportive relationship building with others",
    motivationalAdaptable: "Motivational and adaptable leadership style",
    dynamicNetworking: "Dynamic networking with relationship focus",
    systematicQuality: "Systematic quality management with attention to detail",
    harmoniousConsensus: "Harmonious consensus building among stakeholders",
    flexibleCollaborative: "Flexible collaborative approach to work",
    harmoniousAdaptable: "Harmonious and adaptable working style",
    steadyEnvironment: "Prefers stable and consistent work environment",
    flexible: "Adaptable and flexible",
    collaborative: "Team-oriented and collaborative approach",
    fastPaced: "Dynamic and fast-paced approach",
    structured: "Organized and systematic approach"
  },

  // Communication Style translations
  communication: {
    title: "Communication Style",
    situational: "Situational communication style adapting to context",
    engagingOrganized: "Engaging and organized communication approach",
    diplomaticDecisive: "Diplomatic yet decisive in communication",
    persuasiveResults: "Persuasive communication focused on results",
    enthusiasticOrganized: "Enthusiastic and organized communication style",
    commandingOrganized: "Commanding yet organized in communication",
    collaborativePatient: "Collaborative and patient communication approach",
    strategicMeasured: "Strategic and measured communication style",
    preciseTechnical: "Precise and technical communication approach",
    clearGoal: "Clear goal-oriented communication",
    directAction: "Direct action-focused communication",
    directEfficient: "Direct and efficient communication style",
    inclusiveSupportive: "Inclusive and supportive communication",
    encouragingPatient: "Encouraging and patient communication approach",
    enthusiasticPersuasive: "Enthusiastic and persuasive communication",
    socialSpontaneous: "Social and spontaneous communication style",
    methodicalThorough: "Methodical and thorough communication approach",
    diplomaticPeaceful: "Diplomatic and peaceful communication",
    adaptableSupportive: "Adaptable and supportive communication style",
    peacefulFlexible: "Peaceful and flexible communication approach",
    conciseFocused: "Concise and focused communication",
    informalAccessible: "Informal and accessible communication style",
    conciseAndFocused: "Concise and focused communication",
    listensCarefully: "Listens carefully before responding",
    informalStyle: "Informal and direct approach",
    enthusiastic: "Enthusiastic and engaging communication style"
  },

  style: {
    title: "Professional Style",
    subtitle: "Your natural approach to work and collaboration"
  }
};

export const workStyle = {
  title: "Work Style Preferences",
  adaptableProfessional: "Adaptable and flexible with steady, consistent work environment preferences",
  leadsInspiration: "Leads through inspiration and motivation",
  buildsConsensus: "Builds consensus and drives team alignment",
  strategicLeadership: "Strategic leadership with long-term vision",
  networksSystematic: "Networks systematically while maintaining structure",
  structuredVision: "Structured approach to visionary thinking",
  patientInnovation: "Patient innovation with careful consideration",
  strategicEntrepreneurship: "Strategic entrepreneurship with calculated risks",
  independentExpertise: "Independent expertise with specialized knowledge",
  systematicGoal: "Systematic goal achievement with detailed planning",
  independentAction: "Independent action with self-directed approach",
  autonomousTask: "Autonomous task management with minimal supervision",
  collaborativeTeam: "Collaborative team building with inclusive approach",
  supportiveRelationship: "Supportive relationship building with others",
  motivationalAdaptable: "Motivational and adaptable leadership style",
  dynamicNetworking: "Dynamic networking with relationship focus",
  systematicQuality: "Systematic quality management with attention to detail",
  harmoniousConsensus: "Harmonious consensus building among stakeholders",
  flexibleCollaborative: "Flexible collaborative approach to work",
  harmoniousAdaptable: "Harmonious and adaptable working style",
  steadyEnvironment: "Prefers stable and consistent work environment",
  flexible: "Adaptable and flexible",
  collaborative: "Team-oriented and collaborative approach",
  fastPaced: "Dynamic and fast-paced approach",
  structured: "Organized and systematic approach"
};

export const communication = {
  title: "Communication Style",
  situational: "Situational communication style adapting to context",
  engagingOrganized: "Engaging and organized communication approach",
  diplomaticDecisive: "Diplomatic yet decisive in communication",
  persuasiveResults: "Persuasive communication focused on results",
  enthusiasticOrganized: "Enthusiastic and organized communication style",
  commandingOrganized: "Commanding yet organized in communication",
  collaborativePatient: "Collaborative and patient communication approach",
  strategicMeasured: "Strategic and measured communication style",
  preciseTechnical: "Precise and technical communication approach",
  clearGoal: "Clear goal-oriented communication",
  directAction: "Direct action-focused communication",
  directEfficient: "Direct and efficient communication style",
  inclusiveSupportive: "Inclusive and supportive communication",
  encouragingPatient: "Encouraging and patient communication approach",
  enthusiasticPersuasive: "Enthusiastic and persuasive communication",
  socialSpontaneous: "Social and spontaneous communication style",
  methodicalThorough: "Methodical and thorough communication approach",
  diplomaticPeaceful: "Diplomatic and peaceful communication",
  adaptableSupportive: "Adaptable and supportive communication style",
  peacefulFlexible: "Peaceful and flexible communication approach",
  conciseFocused: "Concise and focused communication",
  informalAccessible: "Informal and accessible communication style",
  conciseAndFocused: "Concise and focused communication",
  listensCarefully: "Listens carefully before responding",
  informalStyle: "Informal and direct approach",
  enthusiastic: "Enthusiastic and engaging communication style"
};
